import React from 'react';
import './style.scss';
import useRoutesAddRoute from './hooks';
import Form from '../../../../../components/molecules/forms';
import { DAY_OPTIONS } from '../../../../../components/atoms/const';
import { firstLetterCapitalized } from '../../../../../components/atoms/func';
import MultipleClientForms from '../../utils/MultipleClientForms';
import BottomButton from '../../utils/BottomButton';
import AddHeader from '../../../../../components/layout/header/add';

function RoutesAddRoute(): React.ReactElement {
  const {
    driverList, formik, id, resDataDetail, loadingSubmit,
  } = useRoutesAddRoute();

  const renderHeader = () => (
    <div>
      <AddHeader
        primary={{ route: '/routes', title: 'Routes' }}
        secondary={id ? { route: `/routes/route/${id}`, title: firstLetterCapitalized(resDataDetail?.name) } : undefined}
        title={id ? 'Edit Route' : 'Add Route'}
      />
      <div className="fz-16 fw-bold mb-2 px-4 px-xl-5" style={{ marginLeft: '20px' }}>Add Route Details</div>
    </div>
  );

  const renderFormRoute = () => (
    <div className="px-4 px-xl-5">
      <Form.Default
        id="name"
        label="Route Name"
        placeholder="Enter Route Name"
        value={formik.values.name}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        isInvalid={formik.touched.name && !!formik.errors.name}
        errorMsg={formik.errors.name}
        className="mb-4"
      />
      <div className="row">
        <div className="col-lg-4 mb-lg-0 mb-4">
          <Form.ReactSelect.Default
            id="userId"
            label="Choose Driver"
            placeholder="Choose Driver"
            options={driverList()}
            value={driverList()?.find((x: any) => x.value.toString() === formik.values.userId.toString())}
            onChange={(e) => {
              if (e) formik.setFieldValue('userId', e.value);
            }}
            isInvalid={formik.touched.userId && !!formik.errors.userId}
            errorMsg={formik.errors.userId}
            onBlur={formik.handleBlur}
          />
        </div>
        <div className="col-lg-4 mb-lg-0 mb-4">
          <Form.ReactSelect.Default
            id="day"
            label="Select Day"
            placeholder="Select Day"
            options={DAY_OPTIONS}
            value={DAY_OPTIONS.find((x) => x.value.toString() === formik.values.day.toString())}
            onChange={(e) => {
              if (e) formik.setFieldValue('day', e.value);
            }}
            isInvalid={formik.touched.day && !!formik.errors.day}
            errorMsg={formik.errors.day}
            onBlur={formik.handleBlur}
          />
        </div>
        <div className="col-lg-4">
          <Form.Switch
            id="repeat"
            label="Repeat"
            active={formik.values.repeat}
            onClick={() => formik.setFieldValue('repeat', !formik.values.repeat)}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {renderHeader()}
      <form
        aria-label="form"
        onSubmit={formik.handleSubmit}
      >
        {renderFormRoute()}
        <div className="w-100 bg-stroke mt-5" style={{ height: '7px' }} />
        <MultipleClientForms id={undefined} formik={formik} />
        <div className="w-100 bg-stroke mt-4 mb-4" style={{ height: '7px' }} />
        <BottomButton loading={loadingSubmit} />
      </form>
    </div>
  );
}

export default RoutesAddRoute;
